/**
 * Application Entry Point
 * 
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../styles/toastify-theme.css';

// ================================
// APPLICATION IMPORTS
// ================================
import App from './App';
import '../styles/global.css';
import { LanguageProvider, ThemeProvider, AuthProvider } from '../contexts';
import { ConfirmDialogProvider } from '../shared/components/ConfirmDialog/ConfirmDialogProvider';
import { initSentry } from './sentry';

// Initialisation du suivi d'erreurs Sentry
initSentry();

/**
 * Point d'entrée de l'application.
 * Configure l'application React avec les différents fournisseurs d'état (routing, SEO, langue, thème, auth).
 */
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <HelmetProvider>
        <LanguageProvider>
          <ThemeProvider>
            <AuthProvider>
              <ConfirmDialogProvider>
                <App />
                <ToastContainer position="bottom-right" autoClose={3000} newestOnTop closeOnClick pauseOnHover theme="light" />
              </ConfirmDialogProvider>
            </AuthProvider>
          </ThemeProvider>
        </LanguageProvider>
      </HelmetProvider>
    </BrowserRouter>
  </React.StrictMode>
);